import _ from 'lodash';
import { Component, ElementRef, OnChanges, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { ActivatedRoute, ParamMap } from '@angular/router';
import { Router } from '@angular/router';
import { FileUploader, FileItem, FileUploaderOptions, ParsedResponseHeaders } from 'ng2-file-upload';
import { FormControl } from '@angular/forms';
import { ConsultRequestService } from '../../../services/index';
import { Country, Location, Address, UserService, UserModel, CountryService, CityService, AirPortService, PortService, Port, Airport, City } from '../../../services/index';
import { ApiService } from '../../../services/api.service';
import { LoadingService, QuotationService } from '../../../services/index';
import { LocationSelectorComponent, OtherCargo } from '../../../containers/index';
import { Util, Codes, LclTotal } from '../../../utils/index'
import bigdecimal from 'bigdecimal';
import {Subscription} from 'rxjs';

declare var $:any;
declare var moment:any;
declare var ga:any;

export class ConsultDetail {
	reqNo: string;

	reqTp: number = 0; //fcl lcl
  transTp: number = 0; //해상 or 항공인듯
	reqDtm: string;
	// sender: string;
	// receiver: string;
	
	orgTp: number;
	orgCntryCd: string;
	orgCntryNm: string;
  orgAdrs: string;
  orgAdrsDtl: string;
	orgLatitude: number;
	orgLongitude: number;
	orgLocationId: number;
	orgAdrsPiece:string;

	desTp: number;
	desCntryCd: string;
	desCntryNm: string;
  desAdrs: string;
  desAdrsDtl: string;
	desLatitude: number;
	desLongitude: number;
	desLocationId: number;
	desAdrsPiece:string;

	imexTp: number;//수입 or 수출										
	inctms: string; 
	transExptDt: string; //운송예정일
	other: string;
	reqSrvcLst: Array<string>;
	crgoLst: Array<CargoDetail>;

	//추가
	stuffYn: number = 0;//적입 가능-0, 불가능-1, 모름-null
	transCfsYn: number = 0;//cfs운송 직접가능-0, 운송요청-1
	stackYn: number;//2단적재가능-1, 불가능-0
  vgmYn: number;//계측요청-1, 요청 안함-0
	modifyDtm: string;
	
	user:UserModel;
	docLst:any;
	isImpossible:number = 0;
	impsbRsnCd:number = null;
	impsbRsnDscrt:string = null;

	stusCd:number = -1;
}

export class CargoDetail {
	commodity: string;
	count: number;
	weight: number;
	value: number;
	crgoTp: string;
	crgoSz: string;
	rfYn: number = 0;
	dgYn: number = 0;
	width: number;
	length: number;
	height: number;
	wghtUnit: string = 'kg';
	volUnit: string = 'cm';
	pkgUnit: number = null;
	valueUnit: string = 'USD';
	hsCode: string;
	minTemp: string = null;
	maxTemp: string = null;
	tempUnit: string;
}


@Component({
	selector: 'container-consult',
	templateUrl: 'consult.html',
	styles: [`
		agm-map {
			height: 400px;
			width: 100%;
		}
	`]
})
export class ConsultComponent implements OnInit, AfterViewInit {
	
	// tmpltOpt: TemplateOptions = new TemplateOptions();
	step:number = 0;
	tabFclLclIndex:number = 0;
	isSelectIncomeExportEmpty: boolean = false;
  locationTypes:Array<string> = ['city', 'port', 'air'];
  orgLocationTypes:Array<string> = ['port'];
  desLocationTypes:Array<string> = ['port'];
	_isRf: boolean = false;
	_isDg: boolean = false;
	orgCurrency: string;
	desCurrency: string;
  
	//지도
  defaultLatitude: number = 37.566535;
	defaultLongitude: number = 126.977969;
  defaultZoom: number = 12;
  scrollWheel1: boolean = false;
  scrollWheel2: boolean = false;
	
	consultDetail: ConsultDetail = new ConsultDetail();
	cloneConsultDetail: ConsultDetail;
	//카고리스트
	cargoListFcl: Array<CargoDetail> = [ new CargoDetail() ];
	cargoListLcl: Array<CargoDetail> = [ new CargoDetail() ];

	reqSrvcLst: Array<string> = [];
	uploader: FileUploader = new FileUploader({});
	cargoEmpty : boolean = true;

	lclCnt: number = 0;
  lclTotalCbm: bigdecimal.BigDecimal = new bigdecimal.BigDecimal('0');
  lclTotalRTCbm: bigdecimal.BigDecimal = new bigdecimal.BigDecimal('0');
  lclTotalWeight: bigdecimal.BigDecimal = new bigdecimal.BigDecimal('0');
  lclTotalGW: bigdecimal.BigDecimal = new bigdecimal.BigDecimal('0');
  lclTotalCW: bigdecimal.BigDecimal = new bigdecimal.BigDecimal('0');

  posting:boolean = false;

  lclPkgUnit: Function = Codes.lclPkgUnit;
  checkTempUnit: Function = Codes.checkTempUnit;
  hsCodeSplit:Function = Codes.hsCodeSplit;

  dateFomatter:Function = Util.dateFomatter;
  currencyFormat:Function = Util.currencyFormat;
  id: string;

  isEdit: boolean = false;

  orgCntryNm: string;
  orgAdrs:string;
  desCntryNm:string;
  desAdrs:string;

  inctms: string;

  orgType: string;
  desType: string;

	otherCargoList;
	otherCargoDataList:Array<OtherCargo>;

  isCfs: boolean = false;
  showTransChoice: boolean = false;
  showGwMethod: boolean = true;

	isCopy: boolean = false;

  crncyList: Array<string> = ['USD', 'EUR'];
  
  hideTransCfsNo: boolean = false;
  
  fromRoute:boolean = false;

	changeImexTpEnable:boolean = false;
	
	//작성자 등록
	userList:Array<UserModel> = new Array<UserModel>();
	filterUserList:Array<UserModel> = new Array<UserModel>();
	isUserListOpen:boolean = false;
	selectUserName:FormControl= new FormControl();
	selectUserIndex:number = 0;
	
	@ViewChild('tab1') tab1:ElementRef;
	@ViewChild('tab2') tab2:ElementRef;

	msdsFileList:Array<any> = new Array<any>();
	cntryList:Array<Country> = new Array<Country>();
	portList:Array<Port> = new Array<Port>();
	airPortList:Array<Airport> = new Array<Airport>();
	orgCityList:Array<City> = new Array<City>();
	desCityList:Array<City> = new Array<City>();

	countryListEeSub:Subscription;
	airportListEeSub:Subscription;
	portListEeSub:Subscription;
	userListEmitSub:Subscription;


	@ViewChild("orgLocation")
	orgLocation: LocationSelectorComponent;
	
	@ViewChild("desLocation")
	desLocation: LocationSelectorComponent;

	allList = {
    cntryList:null,
    ports:null,
    airports:null,
  }


	set isRf(isRf) {
		if (isRf) {
			this.consultDetail.crgoLst[0].rfYn = 1;
			this.consultDetail.crgoLst[0].tempUnit = 'C';
			this._isRf = true;
		} else {
			this.consultDetail.crgoLst[0].rfYn = 0;
			this.consultDetail.crgoLst[0].tempUnit = null;
			this._isRf = false;
		}
	}
	get isRf() { return this._isRf; }

	set isDg(isDg) {
		if (isDg) {
			this.consultDetail.crgoLst[0].dgYn = 1;
			this._isDg = true;
		} else {
			this.consultDetail.crgoLst[0].dgYn = 0;
			this._isDg = false;
		}
	}
	get isDg() { return this._isDg; }
	
	// get crncyList() {
	// 	let crncyList = ['USD', 'EUR'];
	// 	if (this.orgCurrency) crncyList.push(this.orgCurrency);
  //   if (this.desCurrency) crncyList.push(this.desCurrency);
  //   crncyList = _.uniq(crncyList);
	// 	return crncyList;
	// }

	get totalCnt():number {
		let totalCnt:number = 0;
		if (this.consultDetail.reqTp == 0) return totalCnt;

		for (let i = 0 ; i < this.consultDetail.crgoLst.length ; i++) {
			let cargo = this.consultDetail.crgoLst[i];
			if (cargo.count) totalCnt = totalCnt + Number(cargo.count);
		}
		return totalCnt;
  }
  
  isLingoReq:boolean = false;
	wdhRequired=false;
	msds:boolean = false;

	constructor(
		private router: Router, 
		private consultRequestService: ConsultRequestService,
		private quotationService: QuotationService,
    private apiService: ApiService,
		private route: ActivatedRoute,
		private loadingService: LoadingService,
		private userService:UserService,
		private countryService:CountryService,
		private cityService:CityService,
		private airPortService:AirPortService,
		private portService:PortService,

	) {
		
		// ga('set', {page: '/consulting/step1', title: 'Consulting'});
	  // ga('send', 'pageview');
		
		this.consultDetail.reqTp = 0;
		this.consultDetail.transTp = 0;
		this.consultDetail.imexTp = 0;

		this.tabFclLclIndex = this.consultDetail.reqTp;
		this.consultDetail.crgoLst = this.cargoListFcl;

		this.uploader.onErrorItem = function (item: FileItem, response: string, status: number, headers: ParsedResponseHeaders) {
			Util.alertWarn("File(" + item.file.name + ") 업로드 중 에러가 발생했습니다. (업로드 제한 용량은 15Mb 입니다.)");
			return { item: item, response: response, status: status, headers: headers };
		};
	}

	setAllList(){

		this.countryListEeSub = this.countryService.countryListEe.subscribe((cntryList:Array<Country>) =>{
			this.cntryList = cntryList;
			this.allList.cntryList = cntryList;
			this.checkAllListValue();
		});
		
		if(!this.countryService.ingFlag){
			this.countryService.getCountries();
		}

		this.airportListEeSub = this.airPortService.airPortListEe.subscribe((airports:Array<Airport>) =>{
			this.airPortList = airports;
			this.allList.airports = airports;
			this.checkAllListValue();
		});
		if(!this.airPortService.ingFlag){
			this.airPortService.getAirPortList();
		}

		this.portListEeSub = this.portService.portListEe.subscribe((ports:Array<Port>) =>{
			this.portList = ports;
			this.allList.ports = ports;
			this.checkAllListValue();
		});
		if(!this.portService.ingFlag){
			this.portService.getPortList();
		}
	}

	checkAllListValue(){
		if(
      this.allList.airports == null || 
      this.allList.cntryList == null || 
      this.allList.ports == null){
        return;
		}

		this.goNgOnInit();
  }

	goNgOnInit(){	

		this.setCurrentPosition();
    this.route.params.subscribe(params => {
      this.id = params['reqNo']; 
    });

    let that = this;
    
    if(!_.isEmpty(this.id)) {
			this.loadingService.isClose = false;
			this.loadingService.loadingMsg = "견적을 불러오는 중입니다.";
      this.consultRequestService.getConsultDetail(this.id)
      .subscribe(
        resp => {
          that.editConsultDetail(resp.data);
        },
        error => {console.log(error)},
        () => console.log('done')
      );
		}else{
			this.loadingService.isClose = true;
		}
	}

	ngOnInit() {	

		this.setAllList();

		this.userListEmitSub = this.userService.userListEmit.subscribe((userList:Array<UserModel>) => {
			this.userList = userList;
		});
			
		this.userService.getNotLeaveUserList();
	}
	
	ngAfterViewInit(): void {

	}

	ngOnDestroy(){
		if(this.countryListEeSub) this.countryListEeSub.unsubscribe();
		if(this.airportListEeSub) this.airportListEeSub.unsubscribe();
		if(this.portListEeSub) this.portListEeSub.unsubscribe();
		if(this.userListEmitSub) this.userListEmitSub.unsubscribe();
	}

  editConsultDetail(consult) {
    this.isEdit = true;
		let cnsltnReq = consult.cnsltnReq;
    
    this.consultDetail.reqNo = cnsltnReq.reqNo;
    this.consultDetail.reqTp = cnsltnReq.reqTp;
      
		this.consultDetail.transTp = cnsltnReq.transTp;
		this.consultDetail.imexTp = cnsltnReq.imexTp;
      
    this.consultDetail.orgTp = cnsltnReq.orgTp;
    this.consultDetail.orgCntryCd = cnsltnReq.orgCntryCd;
		this.consultDetail.orgCntryNm = cnsltnReq.orgCntryNm;
		
    this.consultDetail.orgAdrs = cnsltnReq.orgAdrs;
		this.consultDetail.orgAdrsDtl = cnsltnReq.orgAdrsDtl;
		
    this.consultDetail.orgLatitude = cnsltnReq.orgLatitude;
    this.consultDetail.orgLongitude = cnsltnReq.orgLongitude;
		this.consultDetail.orgLocationId = cnsltnReq.orgLocationId;
		this.consultDetail.orgAdrsPiece = cnsltnReq.orgAdrsPiece;
		
    this.consultDetail.desTp = cnsltnReq.desTp;
    this.consultDetail.desCntryCd = cnsltnReq.desCntryCd;
    this.consultDetail.desCntryNm = cnsltnReq.desCntryNm;
    this.consultDetail.desAdrs = cnsltnReq.desAdrs;
    this.consultDetail.desAdrsDtl = cnsltnReq.desAdrsDtl;
    this.consultDetail.desLatitude = cnsltnReq.desLatitude;
    this.consultDetail.desLongitude = cnsltnReq.desLongitude;
		this.consultDetail.desLocationId = cnsltnReq.desLocationId;
		this.consultDetail.desAdrsPiece = cnsltnReq.desAdrsPiece;

		if(this.consultDetail.orgTp == 0) { 
			this.orgType = 'Port';
		} else {
			this.orgType = 'Door';
		}

		if(this.consultDetail.desTp == 0) { 
			this.desType = 'Port';
		} else {
			this.desType = 'Door';
		}
    
    this.consultDetail.inctms = cnsltnReq.inctms;
    this.consultDetail.transExptDt = cnsltnReq.transExptDt;
    this.consultDetail.other = cnsltnReq.other;
    this.consultDetail.reqSrvcLst = cnsltnReq.reqSrvcLst;
    this.consultDetail.crgoLst = cnsltnReq.crgoLst;
  
    
    this.consultDetail.stuffYn = cnsltnReq.stuffYn;
    this.consultDetail.transCfsYn = cnsltnReq.transCfsYn;
    this.consultDetail.stackYn = cnsltnReq.stackYn;
    this.consultDetail.vgmYn = cnsltnReq.vgmYn

		this.consultDetail.reqDtm = cnsltnReq.reqDtm;
		
		this.consultDetail.user = cnsltnReq.user;
		this.consultDetail.docLst = cnsltnReq.docLst;

    this.tabFclLclIndex = consult.cnsltnReq.reqTp;
    this.orgCntryNm = consult.cnsltnReq.orgCntryNm;
    // this.orgAdrs = consult.cnsltnReq.orgAdrs;
    this.desCntryNm = consult.cnsltnReq.desCntryNm;
		// this.desAdrs = consult.cnsltnReq.desAdrs;
		
    if(this.consultDetail.reqTp == 0) {
      this.cargoListFcl = this.consultDetail.crgoLst;
    } else {
      this.cargoListLcl = this.consultDetail.crgoLst;
    }

    let copying = this.consultRequestService.isCopying;

    if(copying) {
		this.isCopy = true;
		this.consultDetail.transExptDt = null;
		this.consultDetail.reqNo = null;
		this.consultDetail.reqDtm = null; 
		this.consultDetail.modifyDtm = null;
		this.consultDetail.docLst = [];
	} else {
		for(let i=0; i< cnsltnReq.docLst.length; i++) {
			if(cnsltnReq.docLst[i].docNm == 'MSDS') {
				this.msdsFileList.push(cnsltnReq.docLst[i]);
				this.msds = true;
			}
		}
	}
		
		if(cnsltnReq.stusCd < 2){
			this.consultDetail.stusCd = cnsltnReq.stusCd;
		}
		
		
		if(this.consultDetail.crgoLst){
			let isRfInclude = _.find(this.consultDetail.crgoLst, {rfYn : 1});
			if(isRfInclude){
				this.isRf = true;
			}else{
				this.isRf = false;
			}

			let isDgInclude = _.find(this.consultDetail.crgoLst, {dgYn : 1});
			if(isDgInclude){
				this.isDg = true;
				this.msds = true;
			}else{
				this.isDg = false;
			}
		}

		if(this.tryParseJSON(this.consultDetail.other)) {
			this.otherCargoDataList = JSON.parse(this.consultDetail.other);
		} else {
			this.otherCargoDataList = null;
		}
		
		this.settingOrgDesLocation(cnsltnReq);
    this.userSelectHandler(this.consultDetail.user);
    // this.setIncoterms();
    this.calcLclMeasurement();
		this.autoCfsChecked();
		

		this.loadingService.isClose = true;
		this.consultDetail.inctms = cnsltnReq.inctms;

		if(!this.isCopy){
			this.cloneConsultDetail = _.clone(this.consultDetail);
    }
	}

	tryParseJSON(jsonString){
    try {
        var o = JSON.parse(jsonString);

        if (o && typeof o === "object") {
            return o;
        }
    }
    catch (e) { }

    return false;
  }

	settingOrgDesLocation(cnsltnReq){

		//국가
		for(let i=0;i<this.cntryList.length;i++){
			if(this.cntryList[i].cntryCd == cnsltnReq.orgCntryCd){
				this.orgLocation.cntryListSelectHandler(this.cntryList[i]);
			}
			if(this.cntryList[i].cntryCd == cnsltnReq.desCntryCd){
				this.desLocation.cntryListSelectHandler(this.cntryList[i]);
			}
		}

		if(cnsltnReq.orgTp == 0){
			if(cnsltnReq.transTp == 0){ //port
				this.findPortAirCityValues('PORT', 'ORG', this.orgLocation , this.portList, cnsltnReq);
			}else{ //airport
				this.findPortAirCityValues('AIRPORT', 'ORG', this.orgLocation , this.airPortList, cnsltnReq);
			}
		}else{ // door
			this.findPortAirCityValues('CITY', 'ORG', this.orgLocation , null, cnsltnReq);
		}

		if(cnsltnReq.desTp == 0){
			if(cnsltnReq.transTp == 0){ //port
				this.findPortAirCityValues('PORT', 'DES', this.desLocation , this.portList, cnsltnReq);
			}else{ //airport
				this.findPortAirCityValues('AIRPORT', 'DES', this.desLocation , this.airPortList, cnsltnReq);
			}
		}else{ // door
			this.findPortAirCityValues('CITY', 'DES', this.desLocation , null, cnsltnReq);
		}
	}

	findPortAirCityValues(type:string, position:string, locationObj:LocationSelectorComponent, list:Array<any>, cnsltnReq){

		let locationId:number;
		let address = new Address();
		let adrsDtl:string;
		let cntryCd:string;
		if(position.indexOf('ORG') > -1){
			locationId = cnsltnReq.orgLocationId;
			address.latitude = cnsltnReq.orgLatitude;
			address.longitude = cnsltnReq.orgLongitude;
      address.address = cnsltnReq.orgAdrs;
      this.orgAdrs = cnsltnReq.orgAdrs;
      adrsDtl = cnsltnReq.orgAdrsDtl;
      cntryCd = cnsltnReq.orgCntryCd;

      if(type.indexOf('PORT') > -1){
        this.orgLocationTypes = ['port'];
      };

      if(type.indexOf('CITY') > -1){
        this.orgLocationTypes = ['city'];
      };

      if(type.indexOf('AIRPORT') > -1){
        this.orgLocationTypes = ['air'];
      };
		}else{
			locationId = cnsltnReq.desLocationId;
			address.latitude = cnsltnReq.desLatitude;
			address.longitude = cnsltnReq.desLongitude;
			address.address = cnsltnReq.desAdrs;
      adrsDtl = cnsltnReq.desAdrsDtl;
      cntryCd = cnsltnReq.desCntryCd;
      this.desAdrs = cnsltnReq.desAdrs;

      if(type.indexOf('PORT') > -1){
        this.desLocationTypes = ['port'];
      };

      if(type.indexOf('CITY') > -1){
        this.desLocationTypes = ['city'];
      };

      if(type.indexOf('AIRPORT') > -1){
        this.desLocationTypes = ['air'];
      };
		}
	}

	calcLclMeasurement() {
		Util.calcLclTotal(this.cargoListLcl, (lclToal: LclTotal) => {
      this.lclCnt = lclToal.lclCnt;
      this.lclTotalCbm = lclToal.lclTotalCbm;
      this.lclTotalRTCbm = lclToal.lclTotalRTCbm
      this.lclTotalWeight = lclToal.lclTotalWeight
      this.lclTotalCW = lclToal.lclTotalCW;
    });
	}

	// setImexTp(imexTp){
	// 	this.consultDetail.imexTp = imexTp;
  //   this.isSelectIncomeExportEmpty = false;
  //   this.setIncoterms();
  //   this.autoCfsChecked();
  // }

  setImexTp(imexTp){
    this.consultDetail.imexTp = imexTp;
    this.isSelectIncomeExportEmpty = false;
    
    if(this.consultDetail.orgCntryCd == 'KR' || this.consultDetail.desCntryCd == 'KR') this.changeImexTpEnable = true;
    else if(this.consultDetail.orgCntryCd && this.consultDetail.orgCntryCd != 'KR' && this.consultDetail.desCntryCd && this.consultDetail.desCntryCd != 'KR') this.changeImexTpEnable = true;
    else this.changeImexTpEnable = false;
    
    this.setIncoterms();
  }
  
  changeTransTp(event, type) {
    event.preventDefault();
    if(this.fromRoute) {
      return;
    }

    if(this.isEdit && !this.isCopy) {
      Util.alertWarn('운송 타입(해상/항공)을 변경할 경우 해당 견적을 수정할 수 없습니다.<br />"물류비 견적"을 통해 신규 요청하시기 바랍니다.');
      return;
    } 

    if(type == 'Ocean' && this.consultDetail.crgoLst.length > 1 && (this.isRf || this.isDg)) {
      this.alertError('해상운송 냉장/냉동, 위험물 견적 요청은 단일 항목만 가능합니다.');
      return;
    }

    if(type == 'Ocean') {
      this.consultDetail.transTp = 0;
      this.orgChoice('port');
      this.desChoice('port');
    } else {
      this.consultDetail.transTp = 1;
      this.desChoice('airport');
      this.orgChoice('airport');
      this.changeFclLclTab(1);
    }
  }
  
  orgChoice(type) {
    if(this.fromRoute || this.isLingoReq) return;

    if(type == 'port') {
      this.orgLocationTypes = ['port'];
      this.consultDetail.orgTp = 0;
    }

    if(type == 'airport') {
      this.orgLocationTypes = ['air'];
      this.consultDetail.orgTp = 0;
    }

    if(type == 'city') {
      this.orgLocationTypes = ['city'];
      this.consultDetail.orgTp = 1;
    }
  }

  desChoice(type) {
    if(this.fromRoute || this.isLingoReq) return;
    
    if(type == 'port') {
      this.desLocationTypes = ['port'];
      this.consultDetail.desTp = 0;
    };

    if(type == 'airport') {
      this.desLocationTypes = ['air'];
      this.consultDetail.desTp = 0;
    };

    if(type == 'city') {
      this.desLocationTypes = ['city'];
      this.consultDetail.desTp = 1;
    };
  }
	
  
	setCountry(type: string, country: Country) {
		if (!country) {
			if (type === 'org') {
				this.consultDetail.orgCntryCd = null;
				this.consultDetail.orgCntryNm = null;
				this.orgCurrency = null;
			} else {
				this.consultDetail.desCntryCd = null;
				this.consultDetail.desCntryNm = null;
				this.desCurrency = null;
			}
			
			return;
		}

		this.consultRequestService.getCurrency(country.cntryCd).subscribe(
			data => {
				if (type === 'org') {
					this.orgCurrency = data.crncyCd;
				} else {
					this.desCurrency = data.crncyCd;
				}

				this.crncyList = ['USD', 'EUR'];
				if (this.orgCurrency) this.crncyList.push(this.orgCurrency);
				if (this.desCurrency) this.crncyList.push(this.desCurrency);
				this.crncyList = _.uniq(this.crncyList);
			}
		);
		if (type === 'org') {
			this.consultDetail.orgCntryCd = country.cntryCd;
      this.consultDetail.orgCntryNm = country.cntryNm;
      this.autoCfsChecked();
      this.checkKr();
		} else {
			this.consultDetail.desCntryCd = country.cntryCd;
      this.consultDetail.desCntryNm = country.cntryNm;
      this.autoCfsChecked();
      this.checkKr();
		}
  }
  
  checkKr() {
    if(this.consultDetail.orgCntryCd == 'KR') this.setImexTp(0);
    if(this.consultDetail.desCntryCd == 'KR') this.setImexTp(1);
    if(this.consultDetail.desCntryCd != 'KR') this.setImexTp(0);
  }


	setLocation(type: string, location: Location) {
		
		let tempCnsltnDetail = _.clone(this.consultDetail);

		if (!location) {
			let isChanged = false;
			if (type === 'org') {
				this.consultDetail.orgTp = null;
				this.consultDetail.orgAdrs = null;
				this.consultDetail.orgLatitude = null;
				this.consultDetail.orgLongitude = null;
        this.consultDetail.orgLocationId = null;
        this.orgType = null;        
				isChanged = true;
			} else {
				this.consultDetail.desTp = null;
				this.consultDetail.desAdrs = null;
				this.consultDetail.desLatitude = null;
				this.consultDetail.desLongitude = null;
        this.consultDetail.desLocationId = null;
        this.desType = null;
				isChanged = true;
			}

			// if (isChanged) {
			// 	if (
      //     (!String(this.consultDetail.orgTp) && !String(this.consultDetail.desTp))
      //     || (_.isEmpty(this.consultDetail.orgAdrs) && _.isEmpty(this.consultDetail.desAdrs))
			// 		|| this.consultDetail.orgTp == 1 || this.consultDetail.desTp == 1
			// 	) {
			// 		this.consultDetail.transTp = 0;
			// 		this.locationTypes = ['city', 'port', 'air'];
			// 	}
			// }
			
			return;
		}

		let locationTp = 0;
		let locationTpStr = '';
		if (location.type === 'city') locationTp = 1;
		else {
			if (location.type === 'port') {
				locationTpStr = '[Port]';
				this.consultDetail.transTp = 0;
				this.locationTypes = ['city', 'port'];
			} else {
				locationTpStr = '[Airport]';
				this.consultDetail.transTp = 1;
        this.locationTypes = ['city', 'air'];
        this.changeFclLclTab(1);
			}
		}

		if (type === 'org') {
      this.consultDetail.orgTp = locationTp;
			if (this.consultDetail.orgTp == 0) {
				this.consultDetail.orgAdrs = locationTpStr + ' ' + location.name;
				this.consultDetail.orgAdrsDtl = '';
			}
			this.consultDetail.orgLatitude = location.latitude;
			this.consultDetail.orgLongitude = location.longitude;
      this.consultDetail.orgLocationId = location.locationId;
		} else {
			this.consultDetail.desTp = locationTp;
			if (this.consultDetail.desTp == 0) {
				this.consultDetail.desAdrs = locationTpStr + ' ' + location.name;
				this.consultDetail.desAdrsDtl = '';
			}
			this.consultDetail.desLatitude = location.latitude;
			this.consultDetail.desLongitude = location.longitude;
			this.consultDetail.desLocationId = location.locationId;
    }

    if(type==='org') {
      if(location.type=='city') {
        this.orgType = 'Door';
      } else {
        this.orgType = 'Port';
      }
    }

    if(type==='des') {
      if(location.type=='city') {
        this.desType = 'Door';
      } else {
        this.desType = 'Port';
      }
    }

		this.setIncoterms();

		// if(tempCnsltnDetail != null){
		// 	if(this.consultDetail.orgTp != tempCnsltnDetail.orgTp || this.consultDetail.desTp != tempCnsltnDetail.desTp || this.consultDetail.transTp != tempCnsltnDetail.transTp){
		// 		this.autoCfsChecked();
		// 	}
		// }
	}


	setAddress(type: string, address: Address) {
		if (!address) {
			if (type === 'org') {
				this.consultDetail.orgAdrs = null;
			} else {
				this.consultDetail.desAdrs = null;
			}
			return;
		}

		if (type === 'org') {
			this.consultDetail.orgLatitude = address.latitude;
			this.consultDetail.orgLongitude = address.longitude;
			this.consultDetail.orgAdrs = address.address;
			this.consultDetail.orgAdrsPiece = address.city;
			this.consultDetail.orgTp = 1;
      this.orgType = 'Door';
		} else {
			this.consultDetail.desLatitude = address.latitude;
			this.consultDetail.desLongitude = address.longitude;
			this.consultDetail.desAdrs = address.address;
			this.consultDetail.desAdrsPiece = address.city;
			this.consultDetail.desTp = 1;
      this.desType = 'Door';
		}
  }
  
  setDetailAddress(type: string, address) {
		if (!address) {
			if (type === 'org') {
				this.consultDetail.orgAdrsDtl = null;
			} else {
				this.consultDetail.desAdrsDtl = null;
			}
			return;
		}

		if (type === 'org') {
			this.consultDetail.orgAdrsDtl = address;			
		} else {
			this.consultDetail.desAdrsDtl = address;
		}
	}



	changeFclLclTab(toIndex) {    
		if(!this.checkAir(toIndex)) return ;

		if(this.isEdit && !this.isCopy) {
      Util.alertWarn('화물 타입(FCL/LCL)을 변경할 경우 해당 견적을 수정할 수 없습니다.<br />"물류비 견적"을 통해 신규 요청하시기 바랍니다.');
      return;
    }
		
		this.tabFclLclIndex = toIndex;

		if (toIndex == 0) {
			this.consultDetail.reqTp = 0;
			this.consultDetail.crgoLst = this.cargoListFcl;
			if (this.consultDetail.crgoLst[0].rfYn == 1) this.isRf = true;
			else this.isRf = false;
			if (this.consultDetail.crgoLst[0].dgYn == 1) this.isDg = true;
			else this.isDg = false;
		} else {
			this.consultDetail.reqTp = 1;
			this.consultDetail.crgoLst = this.cargoListLcl;
			if (this.consultDetail.crgoLst[0].rfYn == 1) this.isRf = true;
			else this.isRf = false;
			if (this.consultDetail.crgoLst[0].dgYn == 1) this.isDg = true;
			else this.isDg = false;
    }

    // this.autoCfsChecked();
  }
  
  checkAir(toIndex) {
    if(this.consultDetail.transTp == 1 && toIndex == 0) {
      this.alertError('항공운송은 LCL만 가능합니다.');
			this.tab2.nativeElement.click();
			return false;
		}
		return true;
  }


	dateChange(event) {
    if(event != 'Invalid Date') {
      this.consultDetail.transExptDt = moment(event).format('YYYYMMDD');
    } else {
      this.consultDetail.transExptDt = null;
    }
  }
  
	handleCargoTpSelect(index, $event) {
		if ($event == 'RF' || $event == 'DG') {
			if (this.consultDetail.crgoLst.length > 1) {
				$.sweetModal({
	        content: '단일 화물만 가능합니다.',
          icon: $.sweetModal.ICON_WARNING,
				});

				this.consultDetail.crgoLst[index].crgoTp = null;
				return;
			}
		}

		if ($event == 'RF') {
			this.isRf = true;
			this.isDg = false;
		} else if ($event == 'DG') {
			this.isRf = false;
			this.isDg = true;
			this.msds = true;
		} else {
			this.isRf = false;
			this.isDg = false;
		}
	}

	hasService(srvcCd) {
		if (_.includes(this.consultDetail.reqSrvcLst, srvcCd)) return true;
		else return false;
  }
  
  hasIncoterm(inctmCd) {
		if (_.isEqual(this.consultDetail.inctms, inctmCd)) return true;
		else return false;
  }
  
  checkInctms() {
    let inctms36 = ['DAP', 'DDP', 'EXW'];//'DAT'
    if(_.includes(inctms36, this.consultDetail.inctms)) return true;
    else return false;
  }

	addService($event, srvcCd) {
		let checked = $event.target.checked;
		if (!this.consultDetail.reqSrvcLst) this.consultDetail.reqSrvcLst = [];
		if (checked) {
			if (!_.includes(this.consultDetail.reqSrvcLst, srvcCd)) this.consultDetail.reqSrvcLst.push(srvcCd);
		} else {
			if (_.includes(this.consultDetail.reqSrvcLst, srvcCd)) {
				let index = this.consultDetail.reqSrvcLst.findIndex(value => value == srvcCd);
				if (index >= 0) this.consultDetail.reqSrvcLst.splice(index, 1);
			}
    }

    this.setIncoterms();
  }
  
  removeService(event, srvcCd) {
    if (_.includes(this.consultDetail.reqSrvcLst, srvcCd)) {
      let index = this.consultDetail.reqSrvcLst.findIndex(value => value == srvcCd);
      if (index >= 0) this.consultDetail.reqSrvcLst.splice(index, 1);
    }
  }

  setIncoterms() {
    if(this.consultDetail.imexTp == 0 && ((this.orgType=='Door' && this.desType=='Port') || (this.orgType=='Port' && this.desType=='Port'))) {
      if(_.includes(this.consultDetail.reqSrvcLst, 'INS')) {
        this.consultDetail.inctms = 'CIF';
      } else {
        this.consultDetail.inctms = 'CFR';
      }
    } else if(this.consultDetail.imexTp == 0 && ((this.orgType=='Door' && this.desType=='Door') || (this.orgType=='Port' && this.desType=='Door'))) {
      this.consultDetail.inctms = 'DAP';
    } else if(this.consultDetail.imexTp == 1 && ((this.orgType=='Port' && this.desType=='Door') || (this.orgType=='Port' && this.desType=='Port'))) {
      this.consultDetail.inctms = 'FOB';
    } else if(this.consultDetail.imexTp == 1 && ((this.orgType=='Door' && this.desType=='Door') || (this.orgType=='Door' && this.desType=='Port'))) {
      this.consultDetail.inctms = 'EXW';
    } else {
      this.consultDetail.inctms = null;
    }
  }
  
  changeIncoterms(event, inctmCd) {
    this.consultDetail.inctms = inctmCd;
    if(inctmCd == 'CIF') {
      this.addService(event, 'INS');
    } else if(inctmCd == 'CFR') {
      this.removeService(event, 'INS');
    }
  }

	referChange(event) {
		if (!this.isRf) {
			if (this.consultDetail.reqTp == 1 && this.consultDetail.transTp == 0) {
				$.sweetModal({
	        content: '냉장/냉동 화물은 "컨테이너(FCL)" 또는 "항공운송"을 선택하시기 바랍니다.',
          icon: $.sweetModal.ICON_WARNING,
				});
				event.target.checked = false;
				return;
			}

			if(this.consultDetail.crgoLst.length > 1 && this.consultDetail.transTp != 1) {
				$.sweetModal({
	        content: '복수 품목 선택 시 진행할 수 없습니다. 단일 품목만 입력하시기 바랍니다.',
          icon: $.sweetModal.ICON_WARNING,
        });
				event.target.checked = false;
				return;
			}

			this.consultDetail.crgoLst[0].crgoTp = 'RF';
		} else if (this.isDg) {
      this.consultDetail.crgoLst[0].crgoTp = 'DG'
    } else {
      this.consultDetail.crgoLst[0].crgoTp = 'DR';
    }
    
    this.isRf = !this.isRf;
	}

	dangerChange(event) {
		if (!this.isDg) {
			if (this.consultDetail.reqTp == 1 && this.consultDetail.transTp == 0) {
				Util.alertWarn('위험물인 화물은 "컨테이너(FCL)" 또는 "항공운송"을 선택하시기 바랍니다.');
				event.target.checked = false;
				return;
			}

			if(this.consultDetail.crgoLst.length > 1 && this.consultDetail.transTp != 1) {
				Util.alertWarn('복수 품목 선택 시 진행할 수 없습니다. 단일 품목만 입력하시기 바랍니다.');
				event.target.checked = false;
				return;
			}
			
			if (!this.isRf) this.consultDetail.crgoLst[0].crgoTp = 'DG';
		} else if (this.isRf){
			this.consultDetail.crgoLst[0].crgoTp = 'RF';
		} else {
      this.consultDetail.crgoLst[0].crgoTp = 'DR';
    }

		this.isDg = !this.isDg;
		if(this.isDg) {
			this.msds = true;
		}
  }

	msdsFileAddCheck(event) {
    if(this.isDg) {
      Util.alertWarn('위험물인 화물은 MSDS 파일이 필요합니다.');
      event.target.checked = true;
      return;
    }

		this.msds = !this.msds;
		if(this.msds) {
			event.target.checked = true;
		}
  }

  setCurrentPosition() {
    if ("geolocation" in navigator) {
      navigator.geolocation.getCurrentPosition((position) => {
        this.defaultLatitude = position.coords.latitude;
        this.defaultLongitude = position.coords.longitude;
				this.defaultZoom = 12;
      });
    }
	}
	
	addCargo() {
		if((this.isDg || this.isRf) && this.consultDetail.transTp != 1) {
      if(this.consultDetail.crgoLst.length > 0) {
        $.sweetModal({
          content: '복수 품목 선택 시 진행할 수 없습니다. 단일 품목만 입력하시기 바랍니다.',
          icon: $.sweetModal.ICON_WARNING,
        });
        return;
      }
		}
    
		this.consultDetail.crgoLst.push(new CargoDetail());
	}

	deleteCargo(index) {
		this.consultDetail.crgoLst.splice(index, 1);	
		if (this.consultDetail.crgoLst.length <= 0) {
			this.consultDetail.crgoLst.push(new CargoDetail());
			this.isDg = false;
			this.isRf = false;
		}

		if (this.consultDetail.reqTp == 1) {
			this.calcLclMeasurement();
		}
	}
	
	requestVgm(event) {
		if (event.target.checked) this.consultDetail.vgmYn = 1;
		else this.consultDetail.vgmYn = 0;
  }
  
	toConfirmPage() {

		if(this.consultDetail.crgoLst.some(list=>list.crgoTp == 'OT' || list.crgoTp == 'FR')) {
			this.wdhRequired =true;
		} else {
			this.wdhRequired = false;
		}

		if(!this.consultDetail.user || !this.consultDetail.user.userId){
			this.alertError('작성자가 등록되지 않았습니다.');
      $('html, body').animate({scrollTop: $(".income-export").offset().top - 600}, 1000);
			return;
		}
    
    if(this.consultDetail.imexTp == null || this.consultDetail.imexTp == undefined) {
      this.isSelectIncomeExportEmpty = true;
			$('html, body').animate({scrollTop: $(".income-export").offset().top - 300}, 1000);
			return;
		
		} else if(_.isEmpty(this.consultDetail.orgAdrs)) {
			this.alertError('출발지가 선택되지 않았습니다.');
      $('html, body').animate({scrollTop: $(".org").offset().top - 300}, 1000);
			return;
		
		} else if(_.isEmpty(this.consultDetail.desAdrs)) {
			this.alertError('도착지가 선택되지 않았습니다.');
      $('html, body').animate({scrollTop: $(".des").offset().top - 300}, 1000); 
      return;

    } else if(_.isEmpty(this.consultDetail.inctms)){
      this.alertError('Incoterms가 선택되지 않았습니다.');
      return;
    } else if(this.consultDetail.transTp == 0 && this.consultDetail.crgoLst.length > 1 && (this.isDg || this.isRf)) {
      this.alertError('해상운송 냉장/냉동, 위험물 견적 요청은 단일 항목만 가능합니다.');
      return;
    } else if(this.consultDetail.transTp == 1 && this.tabFclLclIndex == 0) {
      this.alertError('항공운송은 BOX/PALLET(LCL)만 가능합니다.');
      this.changeFclLclTab(1);
			return;
			
    } else if(this.consultDetail.transExptDt == null) {
      if(this.consultDetail.imexTp == 0) {
        this.alertError('출고 예정일이 선택되지 않았습니다.');
      } else {
        this.alertError('입고 희망일이 선택되지 않았습니다.');
      }
      return;
    } else if(this.consultDetail.transCfsYn == 1) {
      if(this.consultDetail.stackYn == null) {
        this.alertError('2단 적재여부를 선택해 주십시오.');
        return;
      }
    } else if(this.msds && (!this.msdsFileList || this.msdsFileList.length <= 0) && ( !this.uploader.queue || this.uploader.queue.length <= 0)) {
      this.alertError('MSDS 파일을 업로드 해 주세요.');
      return;
    }

		
		for (let i = 0 ; i < this.consultDetail.crgoLst.length ; i++) {
			let cargo = this.consultDetail.crgoLst[i];
			
			if (!cargo.count) {
				this.alertError('수량이 누락된 화물이 있습니다.');
				return;
			} else if (!cargo.commodity) {
				this.alertError('품목명이 누락된 화물이 있습니다.');
				return;
      } else if (!_.isEmpty(cargo.hsCode) && cargo.hsCode.length < 6) {
        this.alertError('HS Code는 6자리이상 10자이내로 입력 해 주세요.');
          return;
			} else if (!cargo.weight || cargo.weight == 0) {
				this.alertError('중량이 누락된 화물이 있습니다.');
        return;
			} else if (cargo.rfYn && (cargo.minTemp == null || cargo.maxTemp == null)) {
				this.alertError('냉장 온도가 누락된 화물이 있습니다.');
				return;
			} else if (cargo.dgYn && (!this.msdsFileList || this.msdsFileList.length <= 0) && ( !this.uploader.queue || this.uploader.queue.length <= 0)) {
				this.alertError('MSDS 파일이 누락된 화물이 있습니다.');
				return;
			}

			if (this.consultDetail.reqTp == 0) {
				if (!cargo.crgoTp) {
					this.alertError('컨테이너 타입이 누락된 화물이 있습니다.');
					return;
				} else if (!cargo.crgoSz) {
            this.alertError('컨테이너 크기가 누락된 화물이 있습니다.');
            return;
          
				} else if(cargo.crgoTp == 'OT' || cargo.crgoTp == 'FR') {
          if (!cargo.width) {
            this.alertError('가로 크기가 누락된 화물이 있습니다.');
            return;
          } else if (!cargo.length) {
            this.alertError('세로 크기가 누락된 화물이 있습니다.');
            return;
          } else if (!cargo.height) {
            this.alertError('높이가 누락된 화물이 있습니다.');
            return;
          } else if(!cargo.volUnit) {
            this.alertError('사이즈 단위가 누락된 화물이 있습니다.');
            return;
          } else if(cargo.value) {
							if(!cargo.valueUnit) {
								this.alertError('통화 단위가 누락된 화물이 있습니다.');
								return;
							}
          	}
       		} else if(cargo.value) {
						if(!cargo.valueUnit) {
							this.alertError('통화 단위가 누락된 화물이 있습니다.');
							return;
						}
					}
					if (!cargo.wghtUnit) cargo.wghtUnit = 'kg';
			} else {
				if (cargo.pkgUnit == null || cargo.pkgUnit == undefined) {
					this.alertError('타입이 누락된 화물이 있습니다.');
					return;
				} else if(!cargo.wghtUnit) {
          this.alertError('중량 단위가 누락된 화물이 있습니다.');
          return;
        }  else if (!cargo.width) {
					this.alertError('가로 크기가 누락된 화물이 있습니다.');
					return;
				} else if (!cargo.length) {
					this.alertError('세로 크기가 누락된 화물이 있습니다.');
					return;
				} else if (!cargo.height) {
					this.alertError('높이가 누락된 화물이 있습니다.');
					return;
				} else if(!cargo.volUnit) {
          this.alertError('사이즈 단위가 누락된 화물이 있습니다.');
          return;
        // }
				//  else if (cargo.weight > 10000 || this.lclTotalWeight > 10000) {
        //   this.alertError('총 중량은 10,000kg를 넘을 수 없습니다.');
				// 	return;
        } else if(cargo.value) {
          if(!cargo.valueUnit) {
            this.alertError('통화 단위가 누락된 화물이 있습니다.');
            return;
          }
				}
			}
		}

		if(this.consultDetail.reqTp == 0 && this.consultDetail.stuffYn == 1) {
      if(_.isEmpty(this.otherCargoList)) {
        this.alertError('화물 크기를 입력해주세요.');
        return;
      }

      let otherEmpty = false;
      let unitEmpty = {
        vol: false,
        wght: false,
      };
      let typeEmpty = false;

      this.otherCargoList.map(other => {
        if (!other.pkgUnit) {
          typeEmpty = true;
        } else if (!other.count || !other.height || !other.length || !other.width) {
          otherEmpty = true;
        } else if(!other.wghtUnit) {
          unitEmpty = {...unitEmpty, wght:true};
        } else if(!other.volUnit) {
          unitEmpty = {...unitEmpty, vol:true};
        }
      });

      if(typeEmpty) {
        this.alertError('타입을 입력해주세요.');
        return;
      } else if(otherEmpty) {
        this.alertError('화물 크기를 입력해주세요.');
        return;
      } else if(unitEmpty.vol) {
        this.alertError('사이즈 단위를 입력해주세요.');
        return;
      } else if(unitEmpty.wght) {
        this.alertError('중량 단위를 입력해주세요.');
        return;
      }
    }
		
		if(this.cloneConsultDetail){
			if(this.consultDetail.transTp != this.cloneConsultDetail.transTp){
				$.sweetModal({
					content: "운송 타입을 변경할 경우(ex. 해상(항공)운송 => 항공(해상)운송) 견적재요청 또는 물류비견적을 통해 요청해주세요.",
					icon: $.sweetModal.ICON_WARNING,
				});
				return;
			}else if(this.consultDetail.reqTp != this.cloneConsultDetail.reqTp){
				$.sweetModal({
					content: "LCL(FCL)에서 FCL(LCL)로 변경할 경우 견적재요청 또는 물류비견적을 통해 요청해주세요.",
					icon: $.sweetModal.ICON_WARNING,
				});
				return;
			}
		}
    
    
		// ga('set', {page: '/consulting/step2', title: 'Consulting'});
	  // ga('send', 'pageview');
    this.step = this.step + 1;
    window.scrollTo(0,0);    
	}

	toInsertPage() {
		// ga('set', {page: '/consulting/step1', title: 'Consulting'});
	  // ga('send', 'pageview');
		this.step = this.step - 1;
		if(this.consultDetail.other != null) {
      this.otherCargoDataList = JSON.parse(this.consultDetail.other);
    }
  }
  
  scrollChange(event, targetMp) {
    if(targetMp == 'org') {
      if(this.scrollWheel1 == false) {
        this.scrollWheel1 = true;
      } else {
        this.scrollWheel1 = false;
      }
    } else {
      if(this.scrollWheel2 == false) {
        this.scrollWheel2 = true;
      } else {
        this.scrollWheel2 = false;
      }
    }
  }

  addOthers(event) {
    let other = JSON.stringify(event);
    this.consultDetail.other = other;
    this.otherCargoList = JSON.parse(this.consultDetail.other);
  }

	// autoCfsChecked() {
  //   if((this.consultDetail.reqTp == 0 && this.consultDetail.imexTp == 0 && this.consultDetail.orgTp == 0) || (this.consultDetail.reqTp == 0 && this.consultDetail.imexTp == 1 && this.consultDetail.desTp == 0)) { //Fcl, 수출, 츌벌지 Port
  //     this.showTransChoice = false;
  //     this.consultDetail.stuffYn = 0;
  //     this.consultDetail.transCfsYn = 0;
  //     this.hideTransCfsNo = false;
  //   } else if( this.consultDetail.reqTp == 0 && this.consultDetail.imexTp == 0 && this.consultDetail.orgTp == 1 ){
  //     this.consultDetail.stuffYn = 1;
  //     this.consultDetail.transCfsYn = 1; //cfs신청
  //     this.hideTransCfsNo = true;
  //     this.isCfs = false;
  //     this.showTransChoice = true;
  //   } else if((this.consultDetail.reqTp == 1 && this.consultDetail.imexTp == 0 && this.consultDetail.orgTp == 1)||(this.consultDetail.reqTp == 1 && this.consultDetail.imexTp == 1 && this.consultDetail.desTp == 1)) { //LCL, 수출, 출발지 Door || LCL, 수입, 도착지 Door
  //     this.consultDetail.stuffYn = 1; //직접 불가능
  //     this.consultDetail.transCfsYn = 1; //cfs신청
  //     this.consultDetail.stackYn = 1; //2단적재 가능으로 선택
  //     this.showTransChoice = false;
  //     this.hideTransCfsNo = false;
  //   } else if((this.consultDetail.reqTp == 1 && this.consultDetail.imexTp == 0 && this.consultDetail.orgTp ==0 ) || (this.consultDetail.reqTp == 1 && this.consultDetail.imexTp == 1 && this.consultDetail.desTp ==0)) { //LCL, 수출, 출발지 Port || LCL, 수입, 도착지 Port
  //     this.showTransChoice = false;
  //     this.consultDetail.stuffYn = 0; //직접 가능으로 선택
  //     this.consultDetail.transCfsYn = 0;
  //     this.hideTransCfsNo = false;
  //   } else {
  //     this.showTransChoice = true; //기본으로 변경
  //     this.consultDetail.stuffYn = 0;
  //     this.consultDetail.transCfsYn = 0;
  //     this.isCfs = false;
  //     this.hideTransCfsNo = false;
  //   }
  //   //reqTp, imexTp, transTp, orgTp == 0 :PORT 1:Door, desTp, stuffYn == 0 : 직접적입 가능,  stuffYn == 1:불가능 ,  transCfsYn == 0 : cfs운송 가능 , transCfsYn == 1 : 불가능
	// }	
	
	autoCfsChecked() {
    if(this.consultDetail.orgCntryCd == 'KR' || this.consultDetail.desCntryCd == 'KR') {
      this.showTransChoice = true;
    } else {
      this.showTransChoice = false;
    }
	}	
	
	transCfsChange(event) {
    let value = event.target.value;
    this.consultDetail.transCfsYn = value;
    if(value == 1) {
      this.consultDetail.stackYn = 0;
    } else {
      this.consultDetail.stackYn = null;
    }
  }

  resetStuff() {
    this.consultDetail.transCfsYn = 0;
    this.consultDetail.stackYn = 1;
  }

	alertError(msg: string) {
		$.sweetModal({
			content: msg,
      icon: $.sweetModal.ICON_WARNING,
      onClose: function() {
        $('.sweet-modal-overlay').remove();
        $('body').css('overflow', 'auto');
      }
		});
	}

	consultRequestPost() {
		// this.consultRequestService.post(this.consultDetail);
    // this.uploader.uploadAll();
    /*if(this.consultDetail.reqTp == 0) {
      this.consultDetail.crgoLst.map((crgo:CargoDetail)=>{
        if(crgo.crgoSz != null && crgo.crgoSz.indexOf('HC') > -1){
          crgo.crgoSz = crgo.crgoSz.trim().replace('40', '');
        }
      });  
		}*/
		
		if(!this.msds) {
      this.uploader.queue = null;
		}

    this.loadingService.isClose = false;
    this.loadingService.loadingMsg = '견적 요청 중...';
    this.posting = true;

    let that = this;
		this.consultRequestService.reqConsult(this.uploader, this.consultDetail).subscribe(
			json => {
        this.loadingService.loadingMsg = '';
				this.loadingService.isClose = true;
				if (json.result) {
          this.consultDetail.reqNo = json.data;
					this.modal();
				} else {
          this.alertError('에러가 발생했습니다. - ' + json.errorMsg);
        }
				this.posting = false;
			}
		);
  }
  

  consultEditPost() {
		this.posting = true;
		this.loadingService.isClose = false;
		this.loadingService.loadingMsg = "견적 수정 중...";

		if(!this.msds) {
      this.uploader.queue = null;
		}

		this.consultDetail.isImpossible = 0;
		this.consultDetail.impsbRsnCd = null;
		this.consultDetail.impsbRsnDscrt = null;
		
    this.consultRequestService.editConsult(this.uploader, this.consultDetail).subscribe(
      json => {
				if (json.result) {
          this.consultDetail.reqNo = json.data;
					this.modal();
					if(!this.msds){
						if(this.msdsFileList && this.msdsFileList.length > 0){
							for(let i=0;i<this.msdsFileList.length;i++){
								this.quotationService.deleteFile(this.msdsFileList[i].docId, this.consultDetail.reqNo).subscribe();
							}
						}
					}
				} else {
          this.alertError('에러가 발생했습니다. - ' + json.errorMsg);
				}
				
				
				this.posting = false;
				this.loadingService.isClose = true;
			}
    );
  }


	modal() {
		// ga('set', {page: '/consulting/complete', title: 'Consulting'});
		// ga('send', 'pageview');
		
		if($('.consult-request-modal').hasClass('open')) {
			$('.consult-request-modal').removeClass('open');
		} else {
			$('.consult-request-modal').addClass('open');
		}	
	}

	setFilterUserList(event){
		
		if (!event) return;
    
    let keyword = event.target.value;
    if (!keyword) {
			this.isUserListOpen = false;
		}

		if(keyword.length >= 2){
			keyword = _.upperCase(keyword);
			this.filterUserList =  _.map(_.filter(this.userList,
				(user:UserModel) => {
					if (keyword.length <= 0) return true;
					else if (_.upperCase(user.email).indexOf(keyword) >= 0) return true;
					else if (_.upperCase(user.lastNm + user.firstNm).indexOf(keyword) >= 0) return true;
					else return false;
				}));
		}
	}

	userSelectHandler(user:UserModel){
		this.consultDetail.user = user;
		this.selectUserName.setValue(user.email + '(' + user.lastNm + user.firstNm  + ')');
		this.filterUserList = null;
		this.selectUserIndex = 0;
	}
	
	userListBlur(){
		this.filterUserList = null;
		if(this.consultDetail.user){
			this.selectUserName.setValue(this.consultDetail.user.email + '(' + this.consultDetail.user.lastNm + this.consultDetail.user.firstNm  + ')');
		}
	}

	userKeyDown(event) {
    if (event.keyCode !== 13 && event.keyCode !== 27 && event.keyCode !== 38 && event.keyCode !== 40 ) return;

		switch (event.keyCode) {
			case 13: // enter
				this.userSelectHandler(this.filterUserList[this.selectUserIndex]);
			  break;
			case 27: // escape
			  break;
			case 38: // up
        this.selectUserIndex--;
			  break;
			case 40: // down
				this.selectUserIndex++;
        break;
			default: return;
		}
	}

	moveMyCnsltnReq(){
		if(this.consultDetail.reqNo){
			this.router.navigate(['/quotation/consult-detail', this.consultDetail.reqNo]);
		}else{
			this.router.navigate(['/quotation/consult-list']);
		}
	}

	removeMsdsFile(file:any){
		let that = this;
		$.sweetModal.confirm(file.fileNm + " 파일을 삭제하시겠습니까? 파일을 삭제하는 경우 기존 파일이 삭제됩니다.", function() {
			let body = { docId : file.docId };
			that.quotationService.deleteFile(file.docId, that.id).subscribe(
				resp => {
					let jsonData = resp;
					if(jsonData && jsonData.result) {
						let docList = jsonData.data;
						that.msdsFileList = [];
						for(let i=0; i< docList.length; i++) {
							if(!docList[i].corpId && docList[i].docNm == 'MSDS' && docList[i].delYn != 1) {
                that.msdsFileList.push(docList[i]);
							}
						}
					}
        },
        error => {
          Util.alertWarn(error.errorMsg);
        }
			);
    });
	}
}






// WEBPACK FOOTER //
// ./src/app/containers/quotation/consult/consult.ts